import React, { ReactElement } from 'react';

import Dropdown from 'atomic/dropdown/dropdown';
import { parseSorting } from 'helpers/review';
import type { ReviewListFilter } from 'modules/review/review.interface';
import { ReviewQueryParams, sortDirectionMap, sortFieldsMap } from 'modules/review/review-query-params.enum';
import { useLocation } from 'hooks/use-location';

import './sorting.scss';

interface ReviewListSortingProps {
    handleSorting: (value: ReviewListFilter) => void;
    currentValue: string;
    type: 'company' | 'product';
    options: {
        value: string;
        title: string;
    }[];
}

const ReviewListSorting: React.FC<ReviewListSortingProps> = ({ type, handleSorting, currentValue, options }): ReactElement => {
    const { updateLocation } = useLocation();

    const handleDropdownChange = (value: string | number): void => {
        const parsedSorting = parseSorting(String(value));

        if (parsedSorting) {
            handleSorting(parsedSorting);

            updateLocation({
                query: {
                    [ReviewQueryParams.type]: type === 'product' ? 'produktowe' : null,
                    [ReviewQueryParams.sorting]: [
                        Object.keys(sortFieldsMap).find(key => sortFieldsMap[key] === parsedSorting.sortingField),
                        Object.keys(sortDirectionMap).find(key => sortDirectionMap[key] === parsedSorting.sortingDirection)
                    ].join(','),
                    [ReviewQueryParams.pagination]: null
                }
            });
        }
    };

    return (
        <div className="review-list__sorting">
            <div className="review-list__sorting-label">
                Sortuj wg
            </div>
            <Dropdown
                className="review-list__sorting-dropdown"
                value={currentValue}
                list={options}
                readOnly={true}
                onDropdownChange={handleDropdownChange}
            />
        </div>
    );
};

export default ReviewListSorting;
